import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

const SERVICES = [
  { title: 'Free Consultation', desc: 'A no-cost first conversation to understand your workplace matter and preliminary options.' },
  { title: 'Case Review', desc: 'A thorough paralegal review of your matter to determine the best path forward.' },
  { title: 'Once-Off Case Assistance', desc: 'Full support for a single labour matter for a once-off contribution of R380.' },
  { title: 'Membership', desc: 'Ongoing support, education and priority access for registered members.' },
  { title: 'Administrative Assistance', desc: 'Help preparing letters, forms and correspondence related to your case.' },
  { title: 'Workplace Hearings Support', desc: 'Guidance and preparation ahead of internal disciplinary hearings.' },
  { title: 'Investigations', desc: 'Fact-finding and evidence-gathering support for disputed matters.' },
  { title: 'CCMA Preparation', desc: 'Document preparation and coaching ahead of CCMA conciliation or arbitration.' },
  { title: 'Labour Court Accompaniment', desc: 'Support and accompaniment through labour court proceedings.' },
  { title: "Workers' Rights Education", desc: 'Workshops and materials that help workers understand and exercise their rights.' },
];

export default function Services() {
  return (
    <div>
      <PageHeader
        eyebrow="Our Services"
        title="Support At Every Stage"
        subtitle="From a first free consultation through to case resolution and ongoing membership."
      />
      <section className="section">
        <div className="container grid grid-3">
          {SERVICES.map((s) => (
            <div className="card" key={s.title}>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 40, textAlign: 'center' }}>
          <Link to="/register" className="btn btn-gold">Request Assistance</Link>
        </div>
      </section>
    </div>
  );
}
